<template>
    <div class="d-inline-block">
        <div class="dropdown">
            <button
                class="btn btn-primary"
                type="button"
                @click="showModal">
                Export Translations
            </button>
        </div>
        <div class="modal fade export-translations-modal" id="export-translations-modal" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body align-content-center">
                        <fieldset class="form-group tasks-started">
                            <legend class="close-modal d-flex justify-content-between">
                                <strong>Export Translations</strong>
                                <div class="justify-content-end">
                                    <button class="btn close close-modal" data-dismiss="modal">
                                        <ion-icon name="close"></ion-icon>
                                    </button>
                                </div>
                            </legend>
                        </fieldset>
                        <div class="row mb-3">
                            <div class="col-12">
                                <app-select
                                    label="Language"
                                    :error="languageError"
                                    placeholder="Language"
                                    name="language_id"
                                    id="filter-type"
                                    :is-multiple="false"
                                    :use-search="false"
                                    :options="languages"
                                    @input="selectLanguage"
                                    :is-required="true"
                                ></app-select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12">
                                <app-checkbox
                                    label="Only empty"
                                    v-model="onlyEmpty"
                                    name="onlyEmpty"
                                    id="only-empty">
                                </app-checkbox>
                            </div>
                        </div>
                        <div class="row mb-3" v-if="onlyEmpty">
                            <div class="col-12">
                                <app-select
                                    label="Source languages"
                                    :error="sourceLanguageError"
                                    placeholder="Source Language"
                                    name="source_language_id"
                                    id="filter-type"
                                    :is-multiple="false"
                                    :use-search="false"
                                    :options="sourceLanguages"
                                    @input="selectSourceLanguage"
                                    :is-required="true"
                                ></app-select>
                            </div>
                        </div>
                        <div class="modal-footer clearfix d-flex justify-content-end p-0">
                            <button class="btn btn-danger mt-2" @click="runExport(selectedLanguage.id)" :disabled="runButtonStatus">
                                <ion-icon name="play" class="mb--1"></ion-icon> Run
                            </button>
                        </div>
                    </div>
                </div>

                <loading-overlay :loading="loading"></loading-overlay>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            languages: {
                type: Array,
                default: []
            },
            dataBase: {
                type: String,
            },
            sourceLanguages: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                selectedLanguage: {},
                sourceLanguage: {},
                languageError: '',
                sourceLanguageError: '',
                loading: false,
                onlyEmpty: false,
            }
        },
        computed: {
            runButtonStatus() {
                return (this.onlyEmpty && Object.keys(this.sourceLanguage).length === 0 ) || Object.keys(this.selectedLanguage).length === 0
            }
        },
        methods: {
            showModal() {
                $('#export-translations-modal').modal('show');
            },
            hideModal() {
                $('#export-translations-modal').modal('hide');
            },
            selectLanguage(language_id) {
                this.selectedLanguage = this.languages.find((lang) => {
                    if (lang.id == language_id) {
                        return true;
                    }
                });
            },
            selectSourceLanguage(source_language_id) {
              this.sourceLanguage = this.sourceLanguages.find((lang) => {
                  if (lang.id == source_language_id) {
                      return true
                  }
              });
            },
            runExport(language_id) {
                if (language_id === undefined) {
                    this.languageError = 'Language is required';
                } else if (this.onlyEmpty && Object.keys(this.sourceLanguage).length === 0) {
                    this.sourceLanguageError = 'Source language is required';
                } else {
                    this.loading = true;
                    return axios.post(
                        this.route('run-export'),
                        {'db': this.dataBase, 'language_id': language_id, 'source_language_id': this.sourceLanguage.id, 'only_empty': this.onlyEmpty}
                    ).then((response) => {
                        this.loading = false;
                        let fileDownload = require('js-file-download');
                        const selectedLangTitle = this.selectedLanguage.title;
                        const sourceLangTitle = this.sourceLanguage.title ? '-' + this.sourceLanguage.title : '';
                        fileDownload(response.data, 'Translations(' + selectedLangTitle +  sourceLangTitle + '_' + this.dataBase + ').csv');
                        this.hideModal();
                        // document.location.href = this.route('translations.index', {'db' : this.dataBase});
                    });
                }
            },
        }
    }

</script>

<style scoped lang="scss">
button.btn-primary {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}

button.btn-primary:hover {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}
div.run-connection-modal {
    button.btn.close.close-modal {
        top: -40px;
        position: relative;
    }

    legend.close-modal {
        max-height: 25px;
    }

    .modal-footer {
        padding: 0;
    }

    .modal-footer > * {
        margin: 0;
    }
}

#export-translations-modal .modal-dialog {
    position: relative;
}
</style>
